module.exports = "https://static.wmbcdn.com/uniweb/images/c2314119118cdc2720b805c688be2e28.svg";